import { useSelector } from "react-redux";
import classes from "../../../../../../components/Popover/popover.module.scss";
import classesCarnet from "../../../styles/popover.module.scss";
import DatePicker from "react-datepicker";
import {
  selectEmployee,
  updateEmployeeData,
  updateEmployeeTemporarily
} from "Dashboard/scenes/Carnets/scenes/Main/main.slice";
import {
  ChangeEvent,
  useCallback,
  useEffect,
  useState
} from "react";
import { debounce } from "lodash";
import { useAppDispatch } from "hooks/hooks";
import { FormatDateIso } from "utils/dateUtils";
import { IUpdateEmployeeRequestParams } from "Dashboard/scenes/Carnets/domain/IUpdateEmployeeRequestParams";

const InfoPopover = () => {
  const dispatch = useAppDispatch();
  const employee = useSelector(selectEmployee);
  const [birthDate, setBirthDate] = useState<Date | null>(null);
  const [employedAt, setEmployedAt] = useState<Date | null>(null);

  useEffect(() => {
    const initialBirthDate = employee?.birthDate
      ? new Date(employee.birthDate)
      : null;
    setBirthDate(initialBirthDate);
    const initialEmployedAt = employee?.employedAt
      ? new Date(employee.employedAt)
      : null;
    setEmployedAt(initialEmployedAt);
  }, [employee && employee.employeeId]);

  const delayedEmployeeUpdate = useCallback(
    debounce(async (data: IUpdateEmployeeRequestParams) => {
      try {
        await dispatch(updateEmployeeData(data));
      } catch (err) {
        console.log(err);
      }
    }, 1000),
    []
  );

  const updateBirthDate = async (date: Date) => {
    const old_date = birthDate;
    try {
      if (employee) {
        setBirthDate(date);

        dispatch(
          updateEmployeeTemporarily({
            employeeId: employee.employeeId,
            birthDate: date ? FormatDateIso(date) : null,
          })
        );
        delayedEmployeeUpdate({
          employeeId: employee.employeeId,
          birthDate: date ? FormatDateIso(date) : null,
        });
      }
    } catch (err) {
      setBirthDate(old_date);
      if (employee) {
        dispatch(
          updateEmployeeTemporarily({
            employeeId: employee.employeeId,
            birthDate: old_date ? FormatDateIso(old_date) : null,
          })
        );
      }
    }
  };

  const updateEmployedAt = async (date: Date) => {
    const old_date = employedAt;
    try {
      if (employee) {
        setEmployedAt(date);

        dispatch(
          updateEmployeeTemporarily({
            employeeId: employee.employeeId,
            employedAt: date ? FormatDateIso(date) : null,
          })
        );
        delayedEmployeeUpdate({
          employeeId: employee.employeeId,
          employedAt: date ? FormatDateIso(date) : null,
        });
      }
    } catch (err) {
      setEmployedAt(old_date);
      if (employee) {
        dispatch(
          updateEmployeeTemporarily({
            employeeId: employee.employeeId,
            employedAt: old_date ? FormatDateIso(old_date) : null,
          })
        );
      }
    }
  };

  const onTextChanged = (
    event: ChangeEvent<HTMLTextAreaElement> | ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value } = event.target;

    if (employee) {
      dispatch(updateEmployeeTemporarily({
        employeeId: employee.employeeId,
        [name]: value,
      }));
      delayedEmployeeUpdate({
        employeeId: employee.employeeId,
        [name]: value,
      });
    }
  };

  return (
    <div className={`${classesCarnet.employeeInfoPopover} ${classes.basicPopover}`}>
      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>primljen</label>
          <div className={classesCarnet.datePicker}>
            <DatePicker
              className={`${classes.dateItem} ${classes.itemBorder}`}
              dateFormat="dd.MM.yyyy"
              showMonthDropdown
              showYearDropdown
              onChange={(date: any) => {
                updateEmployedAt(date);
              }}
              selected={employedAt}
            />
          </div>
        </div>
      </div>
      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>datum rodjenja</label>
          <DatePicker
            className={`${classes.dateItem} ${classes.itemBorder}`}
            dateFormat="dd.MM.yyyy"
            showMonthDropdown
            showYearDropdown
            onChange={(date: any) => {
              updateBirthDate(date);
            }}
            selected={birthDate}
          />
        </div>
      </div>
      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>adresa</label>
          <input
            type="text"
            name="address"
            className={classes.itemBorder}
            value={employee?.address ? employee?.address : ""}
            onChange={onTextChanged}
          />
        </div>
      </div>
      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>sup</label>
          <input
            type="text"
            name="idIssuedBy"
            className={classes.itemBorder}
            value={employee?.idIssuedBy ? employee?.idIssuedBy : ""}
            onChange={onTextChanged}
          />
        </div>
      </div>
      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>br. telefona</label>
          <input
            type="text"
            name="phone"
            className={classes.itemBorder}
            value={employee?.phone ? employee?.phone : ""}
            onChange={onTextChanged}
          />
        </div>
      </div>
      <div style={{ marginBottom: "5px" }} className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>br. lične karte</label>
          <input
            type="text"
            name="governmentId"
            className={classes.itemBorder}
            value={employee?.governmentId ? employee?.governmentId : ""}
            onChange={onTextChanged}
          />
        </div>
      </div>
    </div>
  );
};

export default InfoPopover;
